<template>
  <div class="follow-chat">
    <form class="ui form">
      <div class="field">
        <label>送信先まるなげID(カンマ区切り)</label>
        <input type="text" v-model="marunageIds" placeholder="例：555,556,557" />
      </div>
      <div class="field">
        <label>メッセージ</label>
        <textarea v-model="message" rows="30" />
      </div>
      <div class="field">
        <button type="button" class="ui positive button" @click="send()" :class="{'disabled': !ready, 'loading': loading}">送信する</button>
      </div>
    </form>
    <p v-if="count > 0" class="ui message positive">{{ count }}/{{ totalCount }}件送信済み</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      marunageIds: '',
      message: '',
      count: 0,
      totalCount: 0,
      loading: false,
    }
  },
  computed: {
    ready() {
      return this.marunageIds.trim() !== '' && this.message.trim() !== '' && !this.loading;
    }
  },
  methods: {
    async send() {
      if (!confirm('送信しますか？')) {
        return;
      }
      this.loading = true;
      this.count = 0;
      this.totalCount = this.marunageIds.split(',').length;
      try {
        const chunkedMarunageIds = _.chunk(this.marunageIds.split(','), 10);
        for (const marunageIds of chunkedMarunageIds) {
          await this.$http.post('/afadmin/api/marunages/follow_chat', {
            marunage_ids: marunageIds.join(','),
            message: this.message,
          });
          this.count += marunageIds.length;
        }
        alert(`${this.count}件送信しました`);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.follow-chat {
  margin: 25px;
}
</style>
